var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "21px",
    viewBox: "0 0 24 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "messages 1a") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "messages-1a",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#239FB5",
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.2988,2.1211 C2.9078,2.1211 1.8378,3.2961 1.8378,4.6841 L1.8378,9.7321 C1.8378,11.0741 2.8608,12.1681 4.1838,12.2411 L4.1718,13.9921 C1.8768,13.9281 -0.0002,12.0431 -0.0002,9.7311 L-0.0002,4.6841 C-0.0012,2.3341 1.9458,0.3921 4.2978,0.3921 L13.6638,0.3921 C16.0158,0.3921 17.9388,2.3341 17.9388,4.6841 L17.9388,4.7891 L16.2098,4.8091 L16.2098,4.6841 C16.2098,3.2961 15.0538,2.1211 13.6638,2.1211 L4.2988,2.1211 Z M18.6045,11.415 C19.0865,11.415 19.4795,11.035 19.4795,10.551 C19.4795,10.066 19.0875,9.686 18.6045,9.686 L9.8565,9.686 C9.3725,9.686 8.9805,10.066 8.9805,10.551 C8.9805,11.034 9.3725,11.415 9.8555,11.415 L18.6045,11.415 Z M18.6045,14.872 C19.0865,14.872 19.4795,14.491 19.4795,14.008 C19.4795,13.524 19.0875,13.144 18.6045,13.144 L9.8565,13.144 C9.3725,13.144 8.9805,13.524 8.9805,14.008 C8.9805,14.49 9.3725,14.872 9.8555,14.872 L18.6045,14.872 Z M22.9285,9.099 L23.0005,15.234 C23.0195,16.92 21.6675,18.306 19.9805,18.323 L12.3655,18.411 L8.2385,20.523 C7.9765,20.658 7.6615,20.629 7.4245,20.455 C7.1885,20.279 7.0725,19.969 7.1245,19.681 L7.3475,18.437 C6.3495,18.437 5.5325,17.667 5.5215,16.669 L5.4365,9.3 C5.4155,7.613 6.7675,6.229 8.4555,6.21 L19.8375,6.079 C21.5255,6.059 22.9095,7.411 22.9285,9.099 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.e835e90fa709f05c2db9653611d9fdb3.svg";
export { ForwardRef as ReactComponent };